import { Skeleton } from "@tellescope/ui";
import { Card } from "@tellescope/design-system";

export function SubscriptionCardSkeleton() {
  return (
    <Card variant="floating" padding="root">
      <Card.Body className="px-4">
        <div className="flex gap-4">
          <Skeleton className="w-14 h-14 rounded-lg" />
          <div className="flex-1 space-y-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-2/3" />
              <Skeleton className="h-5 w-16 rounded-full" />
            </div>
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-3 w-1/2" />
            <Skeleton className="h-3 w-1/3" />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
